export default {
  club_name: 'Pixbo Wallenstam',
  club_name_short: 'PW',
  stadium_name: '',
  staging_url: 'https://pixbo.api.fangroup.io',
  prod_url: 'https://pixbo.api.fangroup.io',
  api: '/api',
  facebook: 'PixboWallenstam',
  basename: '/pixbo',
  club_logo: '/assets/teams/pixbo.png',
  app_name: 'pixbo',
  websale_name: 'pixbo',
  ntb_team_id: 10030,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'pixbo',
  monolithEnabled: false,
};
